import jwtDecode from 'jwt-decode';

export const selectTimeToAuthExpiry = ({ auth: { authToken } }) => {
  // exp is the expiration time of the token in seconds since the Epoch.
  const expiryTime = jwtDecode(authToken).exp * 1000;
  const currentTime = Date.now();

  return expiryTime - currentTime;
};
